import webSee from '@yaww-websee/core';

//  获取当前环境变量中的REPORT_URL
const REPORT_URL = (import.meta as any).env.VITE_REPORT_URL;

export function initAnalytics() {
  webSee.init({
    dsn: REPORT_URL,
    apply_id: 'aixue-website-pc',
    repeatCodeError: true,
    silentWhiteScreen: false, // 开启白屏检测
    client_type: 20,
    userId: '',
  });
}

export enum EVENTTYPES {
  // 页面展示
  PAGE_SHOW = 10,
  // 模块展示
  MODULE_SHOW = 20,
  // 模块点击
  MODULE_CLICK = 21,
  // 输入
  INPUT = 22,
  // 视频上传
  VIDEO_SERIRE = 30,
  // 系统上报
  SYSTEM_SERIRE = 100,
}

interface ReportParams {
  event_type: EVENTTYPES;
  event_id: string;
  data?: any;
}
export function report(params: ReportParams) {
  webSee.log(params);
}
